import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

type CardNotificationRotationMutationProps = CardNotificationBaseProps & {
  helpCenterUrl: string
}

export function CardNotificationRotationMutation({
  helpCenterUrl,
  ...cardNotificationBaseProps
}: CardNotificationRotationMutationProps) {
  return (
    <CardNotificationBase {...cardNotificationBaseProps}>
      {!!helpCenterUrl && (
        <Button
          variant="ghost"
          size="sm"
          as="a"
          href={helpCenterUrl}
          target="_blank"
          className="!inline-block !px-0 mt-1"
        >
          Ke Pusat Bantuan
        </Button>
      )}
    </CardNotificationBase>
  )
}
